import { DanceShowHero } from 'sections/danceShow/danceShowHero/DanceShowHero';
import { ShowsAbout } from 'sections/danceShow/showsAbout/ShowsAbout';
import { CalculateEvent } from 'sections/shared/calculateEvent/CalculateEvent';

export const DanceShow = () => {
    return (
        <>
            <DanceShowHero />
            <ShowsAbout />
            <CalculateEvent isBgBlack={true} />
        </>
    );
};
